
/////////////START SCRIPT
document.querySelector('#{{ product_form_id }}').addEventListener('submit', function(e) {
  e.preventDefault();
  const form = this;
  const formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Added to cart:', data);
    // Update cart UI
  })
  .catch(error => console.error('Error:', error));
});
/////////////END SCRIPT











/////////////START SCRIPT
document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.promohead-close');
  const promoheadBar = document.getElementById('shopify-section-template--18721801371891__custom_service_block_i4cHCw');

  // Check if promohead was previously dismissed
  const dismissedTime = localStorage.getItem('promoheadDismissedTime');
  const now = new Date().getTime();
  const tenMinutes = 1 * 60 * 1000; // 10 minutes in milliseconds

  if (dismissedTime && (now - dismissedTime < tenMinutes)) {
    if (promoheadBar) {
      promoheadBar.style.display = 'none';
    }
    if (closeButton) {
      closeButton.style.display = 'none'; // Hide button if previously dismissed
    }
  }

  // Close button event listener
  if (closeButton && promoheadBar) {
    closeButton.addEventListener('click', function() {
      promoheadBar.style.display = 'none';
      closeButton.style.display = 'none'; // Hide button when section is dismissed
      localStorage.setItem('promoheadDismissedTime', now);
    });
  }
});
/////////////END SCRIPT








/////////////START SCRIPT
document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.menu-lv-item.has-megamenu');
    let megamenuOverlay = document.querySelector('.megamenu-overlay');

    // Create megamenu-specific overlay if it doesn't exist
    if (!megamenuOverlay) {
        megamenuOverlay = document.createElement('div');
        megamenuOverlay.classList.add('megamenu-overlay');
        document.body.appendChild(megamenuOverlay);
    }

    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 1025) {
                megamenuOverlay.classList.add('active');
            }
        });

        menuItem.addEventListener('mouseleave', () => {
            megamenuOverlay.classList.remove('active');
        });
    });
});
/////////////END SCRIPT









/////////////START SCRIPT
halo.updateContentQuickView = function(handle) {
    const cacheKey = `quickview_${handle}`;
    const cachedContent = localStorage.getItem(cacheKey);

    if (cachedContent) {
        document.querySelector('.halo-popup-content').innerHTML = cachedContent;
        initializeQuickViewScripts(); // Reinitialize any required scripts
        return;
    }

    fetch(`/products/${handle}?view=quick-view`, {
        method: 'GET',
        headers: { 'Accept': 'text/html' }
    })
    .then(response => response.text())
    .then(data => {
        document.querySelector('.halo-popup-content').innerHTML = data;
        localStorage.setItem(cacheKey, data); // Cache the response
        initializeQuickViewScripts();
    })
    .catch(error => console.error('Error fetching Quick View:', error));
};
/////////////END SCRIPT








/////////////START SCRIPT
  document.addEventListener('DOMContentLoaded', function() {
    const quickShopSwatches = document.querySelectorAll('.variants-popup-content .swatch-element');
    
    quickShopSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const variantImg = this.getAttribute('data-variant-img');
        const productId = this.closest('.variants-popup-content').querySelector('form').dataset.id.replace('product-actions-', '');
        const productCard = document.querySelector(`.product-item[data-product-id="${productId}"]`);
        
        if (variantImg && productCard) {
          const cardImage = productCard.querySelector('.card-media img');
          if (cardImage) {
            cardImage.src = variantImg;
            cardImage.srcset = variantImg; // Update srcset for responsive images
          }
        }
      });
    });
  });
/////////////END SCRIPT








/////////////START SCRIPT
  document.querySelectorAll('.variants-popup, .variants').forEach(element => {
  const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
      const productHandle = element.querySelector('[data-product-handle]')?.dataset.productHandle;
      if (productHandle) {
        fetchPopupContent(productHandle).then(content => {
          element.innerHTML = content;
          initializePopupScripts(element);
        });
      }
      observer.disconnect();
    }
  }, { rootMargin: '0px 0px 200px 0px' }); // Load 200px before visible
  observer.observe(element);
});
/////////////END SCRIPT







/////////////START SCRIPT
document.addEventListener('DOMContentLoaded', () => {
  const updateCartAttributes = () => {
    const radioButtons = document.querySelectorAll('input[name="attributes[BLANK_OR_PRINT]"]');
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const selectedValue = event.target.value;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'BLANK_OR_PRINT': selectedValue },
          }),
        })
          .then((response) => response.json())
          .then((cart) => {
            halo.updateSidebarCart(cart); // Refresh cart to reflect changes
          })
          //.catch((error) => console.error('Error updating cart attributes:', error));
      });
    });
  };

  // Initial call and rebind after cart updates
  updateCartAttributes();
  document.addEventListener('cart-update', updateCartAttributes);
});
/////////////END SCRIPT




















  



/////////////START SCRIPT THIS CODE IS RELATED TO ASSURING THE SELECTION OF THE CORRECT VARIANT ex NOT 4XL
  // Add to your theme.js or a custom script
//document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
//  form.addEventListener('submit', function(event) {
//    const sizeInput = this.querySelector('input[name^="properties[Size]"]:checked');
//    if (sizeInput) {
//      const hiddenInput = document.createElement('input');
//      hiddenInput.type = 'hidden';
//      hiddenInput.name = 'properties[Size]';
//      hiddenInput.value = sizeInput.value;
//      this.appendChild(hiddenInput);
//    }
//  });
//});
/////////////END SCRIPT
 
/////////////START SCRIPT SIMILAR TO BEFORE MORE ADVANCED THIS CODE IS RELATED TO ASSURING THE SELECTION OF THE CORRECT VARIANT ex NOT 4XL
//document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
//form.addEventListener('submit', function(event) {
//const productId = this.closest('[data-product-id]')?.dataset.productId;
//if (productId) {
//const sizeInput = this.querySelector(`input[name="properties[Size]"]:checked`);
//if (sizeInput) {
// Remove any existing hidden inputs to avoid duplicates
//const existingHidden = this.querySelector('input[name="properties[Size]"][type="hidden"]');
//if (existingHidden) existingHidden.remove();
        
// Add new hidden input for properties[Size]
//const hiddenInput = document.createElement('input');
//hiddenInput.type = 'hidden';
//hiddenInput.name = 'properties[Size]';
//hiddenInput.value = sizeInput.value;
//this.appendChild(hiddenInput);
        
// Temporarily disable the radio input to prevent duplicate submission
//sizeInput.removeAttribute('name');
//}
//}
//});
//});
/////////////END SCRIPT  












  /////////////START SCRIPT  {% comment %} IMPORTANT 06-17-2025 FOR CUSTOM VARIANTs {% endcomment %}
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('#swatch-{{ formId }}-{{ sectionId }}-{{ list }}');
    const sizeInputs = form.querySelectorAll('input[name="properties[Size]"]');
    const addToCartBtn = form.querySelector('[data-btn-addToCart]');

    sizeInputs.forEach(input => {
      input.addEventListener('change', function() {
        // Ensure the selected size is stored or processed as needed
        form.querySelector('input[name="properties[Size]"]').value = this.value;
      });
    });

    addToCartBtn.addEventListener('click', function(e) {
      const selectedSize = form.querySelector('input[name="properties[Size]"]:checked');
      if (!selectedSize) {
        e.preventDefault();
        alert('Please select a size.');
      }
    });
  });
/////////////END SCRIPT 









/////////////START SCRIPT
  document.addEventListener('DOMContentLoaded', function() {
  function updateInputs() {
    const isMobile = window.innerWidth < 768;
    const mobileRadios = document.querySelectorAll('.mobile-selector .swatch-radio');
    const desktopSelect = document.getElementById('size-desktop');

    if (isMobile) {
      mobileRadios.forEach(radio => radio.removeAttribute('disabled'));
      if (desktopSelect) desktopSelect.setAttribute('disabled', 'disabled');
    } else {
      mobileRadios.forEach(radio => radio.setAttribute('disabled', 'disabled'));
      if (desktopSelect) desktopSelect.removeAttribute('disabled');
    }
  }

  // Run on load
  updateInputs();

  // Run on window resize
  window.addEventListener('resize', updateInputs);
});




document.addEventListener('DOMContentLoaded', function() {
  function updateInputs() {
    const isMobile = window.innerWidth < 768;
    const desktopRadios = document.querySelectorAll('.desktop-selector .swatch-radio');

    if (isMobile) {
      desktopRadios.forEach(radio => radio.setAttribute('disabled', 'disabled'));
    } else {
      desktopRadios.forEach(radio => radio.removeAttribute('disabled'));
    }
  }

  // Run on load and resize
  updateInputs();
  window.addEventListener('resize', updateInputs);
});
/////////////END SCRIPT






  
 

/////////////START SCRIPT 
 // document.addEventListener('DOMContentLoaded', function() {
   // Scope to Quick Shop forms only
  //  const forms = document.querySelectorAll('[id^="swatch-"]');
  //  forms.forEach(form => {
      // Ensure this is a Quick Shop form (contains .variants-popup-content)
  //    if (form.closest('.variants-popup-content')) {
  //     const sizeInputs = form.querySelectorAll('input[name="properties[Size]"]');
  //      const addToCartBtn = form.querySelector('[data-btn-addToCart]');
  //
   //       sizeInputs.forEach(input => {
  //          input.addEventListener('change', function() {
            // Update only the current form’s selected size
  //            const selectedInput = form.querySelector('input[name="properties[Size]"]:checked');
  //            if (selectedInput) {
  //              // No need to set a single input value; let the form handle it
   //             console.log(`Selected size for form ${form.id}: ${selectedInput.value}`);
   //           }
   //         });
   //       });
  //
   //       addToCartBtn.addEventListener('click', function(e) {
   //         const selectedSize = form.querySelector('input[name="properties[Size]"]:checked');
   //         if (!selectedSize) {
  //            e.preventDefault();
  //            alert('Please select a size.');
   //         }
  //        });
  //      }
  //    });
   // });
/////////////END SCRIPT 











/////////////////////////////// LAZY LOAD ? ///////////////////////
class LazyLoad {
constructor() {
this.LAZY_CLASS = 'layz-load';
this.LOADED_CLASS = 'loaded';
}

init() {
this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
rootMargin: '0px 0px -100px 0px',
threshold: 0.1
});

document.querySelectorAll(`.${this.LAZY_CLASS}`).forEach(el => {
this.observer.observe(el);
});
}

onIntersection(entries) {
entries.forEach(entry => {
if (entry.isIntersecting) {
const el = entry.target;
// Load content: e.g., from data-src (for iframes/img) or fetch if data-url
if (el.dataset.url) {
fetch(el.dataset.url)
.then(res => res.text())
.then(html => { el.innerHTML = html; });
} else if (el.dataset.src) {
el.src = el.dataset.src; // For embeds
}
el.classList.add(this.LOADED_CLASS);
this.observer.unobserve(el);
}
});
}
}

document.addEventListener('DOMContentLoaded', () => {
new LazyLoad().init();
});

/////////////////////////////// END LAZY LOAD ? ///////////////////////












